import { render } from "./company_messages.html?vue&type=template&id=03ada628&external"
import script from "./company_messages.js?vue&type=script&lang=js&external"
export * from "./company_messages.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__